import { Operation } from 'flow/service/changelog/types';
import type { HistoryAction } from 'flow/service/history/constants';
import { historyAction } from 'flow/service/history/constants';

export const historyActionTextMap: Record<HistoryAction, string> = {
  [historyAction.undo]: 'Undo',
  [historyAction.redo]: 'Redo',
};

export const operationTextMap: Record<Operation, string> = {
  [Operation.Add]: 'add',
  [Operation.Modify]: 'update',
  [Operation.Remove]: 'delete',
};
